<div class="loader-simulador" *ngIf="loading">
  <div class="spinner-border text-dark">
    <span class="visually-hidden">Loading...</span>
  </div>
  <br />
  <h5 class="m-3">Cargando...</h5>
</div>
